import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@mui/material';
import Page from '../../layout/Page';
import { DataTable } from '../../components/DataTable';
import ListPageActions from '../../components/ListPageActions';
import DownloadButton from '../../components/DownloadButton';
import SwitchCell from '../../components/SwitchCell';
import CustButton from '../../ui/CustButton';
import DateFilterCell from '../../components/DateFilterCell';
import DialogConfirm from '../../components/DialogConfirm';
import usePaginationV2 from '../../util/usePaginationV2';

import { Add, Edit, Delete, Settings, WrapText } from '@mui/icons-material';

import SGKMasterParameterCrudDialog from './SGKMasterParameterCrudDialog';
import DynamicOptions from '../../components/DynamicOptions';
import FilterOptionEnum from '../../enum/FilterOptionEnum';
import paramTipiEnum from '../../enum/paramTipiEnum';
import useGlobal from '../../util/Global';
import SGKMasterParameterservice from '../../service/MasterServices/SGKMasterParameterService';

const SGKMasterParameterPage = ({ title }) => {
    const { t } = useGlobal();
    const [selectedItems, setSelectedItems] = useState([]);
    const [deleteItem, setDeleteItem] = useState(null);
    const [actionType, setActionType] = useState(null);
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedKey, setSelectedKey] = useState(null);
    const [isDetayDialogOpen, setDetayDialogOpen] = useState(false);
    const [isTruncated, setIsTruncated] = useState(true);
    const [crudTip, setCrudTip] = useState('');

    const handleSwitchChange = async (item, newCheckedVal) => {
        console.log(item, newCheckedVal);
        let result = await SGKMasterParameterservice.update({
            id: item.id,
            durum: !item.durum
        });
        mainDataList.search();
        return true;
    };

    const handleToggle = () => {
        setIsTruncated(prevState => !prevState);
    };

    const handleDeleteAction = async () => {
        if (!deleteItem) return;
        setLoading(true);
        try {
            const result = await SGKMasterParameterservice.delete(deleteItem.id);
            if (result) {
                mainDataList.search();
            }
        } catch (error) {
            console.error('Action failed:', error);
        } finally {
            setLoading(false);
            setOpenDialog(false);
        }
    };

    const openDetayDialog = (id) => {
        setSelectedKey(id);
        setDetayDialogOpen(true);
    };
    const closeDetayDialog = () => {
        setSelectedKey(null);
        setDetayDialogOpen(false);
    };

    const ParseDynamicItem = (item) => {
        switch (item.paramTipi) {
            case 4:
                return <SwitchCell item={item} checked={item.value == 'true'} />
            default:
                return item.value;
        }
    }

    const handleAction = async () => {
        const selectedIds = Object.values(selectedItems);
        if (!selectedIds.length) return;
        setLoading(true);
        try {
            let result;
            if (actionType === 'Reset') {
                result = await SGKMasterParameterservice.bulkReset(selectedIds);
            } else if (actionType === 'Set') {
                result = await SGKMasterParameterservice.bulkSet(selectedIds);
            }
            if (result) {
                mainDataList.search();
            }
        } catch (error) {
            console.error('Action failed:', error);
        } finally {
            setLoading(false);
            setOpenDialog(false);
        }
    };

    const columns = [
        { name: "paramterName", label: t('col.paramterName'), textAlign: "left" },
        { name: "paramKey", label: t('col.paramKey'), textAlign: "left" },
        {
            name: "paramTipi",
            label: t('col.paramTipi'),
            textAlign: "center",
            execute: (item) => paramTipiEnum[item],
            searchable: true,
            searchType: "select",
            selectOptions: <FilterOptionEnum enumObject={paramTipiEnum} />
        },

        { name: "aciklama", label: t('col.aciklama'), textAlign: "left" },
        {
            name: "value",
            label: t('col.value'),
            textAlign: "center",
            passItem: true,
            execute: (item) => ParseDynamicItem(item)
        },

        {
            sortable: false,
            searchable: false,
            passItem: true,
            textAlign: 'Center',
            title: 'action',
            execute: (item) => (
                <>
                    <IconButton
                        onClick={() => handleOpenCrudDialog(item, 'Update')}
                        color='warning'
                        variant='contained'
                        title={t('rowActions.update')}
                        size='small'>
                        <Edit />
                    </IconButton>
                    <IconButton
                        onClick={() => openConfirmDialog(item)}
                        color='error'
                        variant='contained'
                        title={t('rowActions.delete')}
                        size='small'>
                        <Delete />
                    </IconButton>
                </>
            ),
        },



    ];

    const mainDataList = usePaginationV2({
        service: SGKMasterParameterservice,
        pageColumns: columns,
        defaultOrderBy: { name: 'Id', type: 'Desc' },
    });

    const [crudItem, setCrudItem] = useState(null);
    const [onCrudDialogOpen, setCrudDialogOpen] = useState(false);

    const handleOpenCrudDialog = (data, tip) => {
        setCrudItem(data);
        setCrudDialogOpen(true);
        setCrudTip(tip);
    };

    const handleClose = async () => {
        setCrudDialogOpen(false);
        await mainDataList.search([]);
    };

    const openConfirmDialog = (item) => {
        setDeleteItem(item);
        setOpenDialog(true);
    };
    const closeConfirmDialog = () => setOpenDialog(false);

    const ActionButtons = () => (
        <ListPageActions
            left={
                <>
                    <CustButton
                        icon={Add}
                        onClick={() => handleOpenCrudDialog(null, 'Create')}
                        style={{ marginLeft: 10 }}
                        disabled={loading}
                    >
                        {title + ' ' + t('button.add')}
                    </CustButton>
                </>
            }
            right={
                <>
                    <CustButton
                        icon={WrapText}
                        onClick={() => handleToggle()}
                        style={{ marginLeft: 10 }}
                        disabled={loading}
                    />
                </>
            }
        >
            <DownloadButton service={mainDataList} disabled={loading} />
        </ListPageActions>
    );

    return (
        <Page title={title}>
            <ActionButtons />
            <DataTable
                columns={columns}
                {...mainDataList}
                loading={loading}
            />
            <ActionButtons />
            <SGKMasterParameterCrudDialog
                open={onCrudDialogOpen}
                onClose={handleClose}
                data={crudItem}
                crudTip={crudTip}
                title={title}
            />

            <DialogConfirm
                open={openDialog}
                onClose={closeConfirmDialog}
                onConfirm={handleDeleteAction}
                title={t('delete.title')}
            />
        </Page>
    );
};
export default SGKMasterParameterPage;